import React, { useEffect, useState } from "react";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { Link } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Tooltip, OverlayTrigger, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  delete_Record,
  ActiveInactive_Record,
  errorMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { useFilter } from "../../../../context/FilterContext";
import {
  POST_GetCourierDDLList,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetReportDispatchList,
  POST_GetReportDispatchPrintLabel,
  POST_ReportDispatchActiveInActive,
  POST_ReportDispatchDelete,
  POST_ReportDispatchPrint,
} from "../../../helpers/url_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const ReportDispatch = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "report-dispatch" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "report-dispatch" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "report-dispatch" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "report-dispatch" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [customerOptions, setCustomerList] = useState([]);
  const [courierOptions, setCourierList] = useState([]);
  const [reportDispatchList, setReportDispatchList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  //const [hTMLContents, setHTMLContents] = useState("");

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate:
        filter && filter?.page == "report-dispatch"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "report-dispatch"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "report-dispatch"
          ? filter?.CustomerIDEncrypted
          : "",
      ReportDispatchNo:
        filter && filter?.page == "report-dispatch"
          ? filter?.ReportDispatchNo
          : "",
      TCNo: filter && filter?.page == "report-dispatch" ? filter?.TCNo : "",
      InwardNo:
        filter && filter?.page == "report-dispatch" ? filter?.InwardNo : "",
      DeliveredTo:
        filter && filter?.page == "report-dispatch" ? filter?.DeliveredTo : "",
      CourierIDEncrypted:
        filter && filter?.page == "report-dispatch"
          ? filter?.CourierIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "report-dispatch" ? filter?.CustomerName : "",
      HTMLContentsPrintLabel: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      ReportDispatchNo,
      TCNo,
      InwardNo,
      DeliveredTo,
      CourierIDEncrypted,
      CustomerName,
      HTMLContentsPrintLabel,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      ReportDispatchNo: "",
      TCNo: "",
      InwardNo: "",
      DeliveredTo: "",
      CourierIDEncrypted: "",
      CustomerName: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    getCustomerDDL();
    getCourierDDL();
  }, []);

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCourierDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCourierDDLList, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCourierList(
            response?.List?.map((item) => ({
              label: item.CourierName,
              value: item.CourierIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "report-dispatch",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      ReportDispatchNo: ReportDispatchNo,
      TCNo: TCNo,
      InwardNo: InwardNo,
      DeliveredTo: DeliveredTo,
      CourierIDEncrypted: CourierIDEncrypted,
      CustomerName: CustomerName,
    });

    setIsLoading(true);
    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      TCNo: TCNo,
      InwardNo: InwardNo,
      CustomerIDEncrypted: CustomerIDEncrypted,
      ReportDispatchNo: ReportDispatchNo,
      DeliveredTo: DeliveredTo,
      CourierIDEncrypted: CourierIDEncrypted,
      ReportDispatchDateFrom: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ReportDispatchDateTo: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    };
    await post(POST_GetReportDispatchList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setReportDispatchList(response?.List);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getReportDispatchPrint = async (id) => {
    setIsLoading(true);
    let payload = {
      ReportDispatchIDEncrypt: id,
    };
    post(POST_ReportDispatchPrint, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getReportDispatchPrintLabel = async (id) => {
    setIsLoading(true);
    let payload = {
      ReportDispatchIDEncrypt: id,
    };
    post(POST_GetReportDispatchPrintLabel, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          formikFilter.setFieldValue(
            "HTMLContentsPrintLabel",
            response?.HTMLContents
          );
          setTimeout(() => {
            const iframe = document.getElementById("iFrames");
            if (iframe) {
              iframe.contentWindow.print();
            }
            setIsLoading(false);
          }, 500);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Report Dispatch</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "} Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i>Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 35 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      // to="/add-report-dispatch"
                      to={`/add-report-dispatch/${window.btoa(
                        "0"
                      )}/${window.btoa("0")}`}
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-plus"></i> Add Report Dispatch
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <label> Dispatch Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Dispatch No"
                              name="ReportDispatchNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"TC No..."}
                              component={CustomInput}
                            />
                          </Col>
                        </Row>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCutomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          {/* <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              options={customerOptions}
                              component={CustomSelect}
                              //isClearable={false}
                            />
                          </Col> */}
                          <Col lg={3}>
                            <Field
                              label="Delivered To"
                              name="DeliveredTo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Courier"
                              name="CourierIDEncrypted"
                              placeholder={"Select Courier"}
                              options={courierOptions}
                              component={CustomSelect}
                              //isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="ReportDispatch-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="ReportDispatch-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="8%"></th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ReportDispatchNo");
                          }}
                        >
                          Dispatch No{" "}
                          <span className="ml-1">
                            {sortBy == "ReportDispatchNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ReportDispatchDate");
                          }}
                        >
                          Dispatch Date{" "}
                          <span className="ml-1">
                            {sortBy == "ReportDispatchDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("DeliveredTo");
                          }}
                        >
                          Delivered To{" "}
                          <span className="ml-1">
                            {sortBy == "DeliveredTo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("DeliveredBy");
                          }}
                        >
                          Delivered By{" "}
                          <span className="ml-1">
                            {sortBy == "DeliveredBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "13%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("CourierName");
                          }}
                        >
                          Courier{" "}
                          <span className="ml-1">
                            {sortBy == "CourierName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportDispatchList?.length > 0 ? (
                        reportDispatchList?.map((item, indx) => (
                          <>
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  //whiteSpace: "normal",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                                rowSpan={item.TCNos ? 2 : 1}
                              >
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 35 && x?.IsEdit
                                )?.length > 0 ? (
                                  <Link
                                    to={
                                      item?.IsHold == true
                                        ? "#"
                                        : `/edit-report-dispatch/${window.btoa(
                                            item.ReportDispatchIDEncrypt
                                          )}`
                                    }
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {/* {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 35 && x?.IsActive
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className={`icon-box icon-box-md bg-${
                                    //   item.IsActive == true ? "success" : "danger"
                                    // }-light me-1`}
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_ReportDispatchActiveInActive,
                                        {
                                          ReportDispatchIDEncrypt:
                                            item.ReportDispatchIDEncrypt,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypt:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.ReportDispatchNo
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )} */}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 35 && x?.IsDelete
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        delete_Record(
                                          POST_ReportDispatchDelete,
                                          {
                                            ReportDispatchIDEncrypt:
                                              item.ReportDispatchIDEncrypt,
                                            ModifiedByEncrypt:
                                              AuthUser?.ReferenceIDEncrypt
                                                ? AuthUser?.ReferenceIDEncrypt
                                                : "0",
                                          },
                                          setIsLoading,
                                          fnCallback,
                                          item.ReportDispatchNo
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Print"
                                  onClick={(e) => {
                                    if (item?.IsHold == false) {
                                      getReportDispatchPrint(
                                        item.ReportDispatchIDEncrypt
                                      );
                                    }
                                  }}
                                  disabled={item?.IsHold}
                                >
                                  {SVGICON.Printer}
                                </Link>
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Print Label"
                                  onClick={(e) => {
                                    if (item?.IsHold == false) {
                                      getReportDispatchPrintLabel(
                                        item.ReportDispatchIDEncrypt
                                      );
                                    }
                                  }}
                                  disabled={item?.IsHold}
                                >
                                  <i
                                    className="fa fa-print"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.ReportDispatchNo}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.ReportDispatchDate}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.CustomerName}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.InwardNo}
                              </td>

                              {/* <td
                                style={{
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                              >
                                {item.ProjectName}
                                {"-"}
                                {item.ReportingTo}
                                {item.DeliveredTo ? "-" : ""}
                                {item.DeliveredTo}
                              </td> */}
                              <td
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                }}
                                // className="popupOverlay border-bottom-0 pb-0"
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.ProjectName}
                                        {" - "}
                                        {item.ReportingTo}
                                        {item.DeliveredTo ? " - " : ""}
                                        {item.DeliveredTo}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    {item.ProjectName}
                                    {" - "}
                                    {item.ReportingTo}
                                    {item.DeliveredTo ? " - " : ""}
                                    {item.DeliveredTo}
                                  </span>
                                </OverlayTrigger>
                              </td>

                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.DeliveredBy}
                              </td>
                              {/* <td
                                style={{
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                              >
                                {item.CourierName}
                              </td> */}

                              <td
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                }}
                                // className="popupOverlay border-bottom-0 pb-0"
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.CourierName}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.CourierName}</span>
                                </OverlayTrigger>
                              </td>
                            </tr>
                            {item.TCNos ? (
                              <tr key={`${indx}.1`}>
                                {/* <td></td> */}
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                    // verticalAlign: "top",
                                  }}
                                  // className="p-1"
                                >
                                  {/* <table className="table dataTable no-footer mb-0">
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            verticalAlign: "top",
                                          }}
                                          className="border-bottom-0 pt-1 pb-0"
                                        > */}
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary mb-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "45px",
                                      }}
                                    >
                                      TC No : &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item.TCNos}
                                    </div>
                                  </div>
                                  {/* </td>
                                      </tr>
                                    </tbody>
                                  </table> */}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: "none" }}>
              <iframe
                id="iFrames"
                title="Print Label"
                width="100%"
                style={{ height: "100vh", display: "none" }}
                frameBorder="0"
                srcDoc={HTMLContentsPrintLabel}
              ></iframe>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default ReportDispatch;
